<div class="flex flex-col gap-3">
  <div class="flex flex-col gap-1.5">
    <label tuiLabel>
      <input tuiSwitch type="checkbox" size="s" [ngModel]="capture.liveEnabled()" (ngModelChange)="onLiveToggle($event)" />
      <span tuiTitle>
        Follow latest pull
        <span tuiSubtitle>Re-analyzes as new pulls upload during a live log.</span>
      </span>
    </label>
    @if (capture.liveEnabled() && capture.statusText()) {
      <span class="inline-flex items-center gap-2 text-body text-muted"><tui-pulse class="mx-1" [playing]="true" />{{ capture.statusText() }}</span>
    }
  </div>

  <div class="flex flex-col gap-1.5">
    <label tuiLabel>
      <input tuiSwitch type="checkbox" size="s" [ngModel]="capture.recordToggleOn()" [disabled]="capture.isStarting()" (ngModelChange)="onRecordToggle($event)" />
      <span tuiTitle>
        Record game client
        <span tuiSubtitle>Stays in this browser session, nothing is uploaded</span>
      </span>
    </label>
    @if (capture.isStarting()) {
      <tui-loader size="xs" class="self-start text-muted" [inheritColor]="true" textContent="Pick a window..." />
    } @else if (capture.isCapturing()) {
      <span class="inline-flex items-center gap-2 text-body text-muted"><tui-pulse class="mx-1" [playing]="true" />Recording "{{ capture.sourceLabel() }}" in the background</span>
    } @else if (capture.captureError()) {
      <span class="text-body text-critical">{{ capture.captureError() }}</span>
    }
  </div>
</div>
